import { _normalize, collectionCommand } from 'volta/utils/api';

import Task, { TaskCommands } from './task';
import { Type } from '@warp-drive/core-types/symbols';
import type {
  ICreateTaskCmd,
  IDeleteTaskCmd,
  IReopenTaskCmd,
  IResolveTaskCmd,
  IUpdateTaskCmd
} from './types/tasks';

interface ILinkedEntityPayload {
  name: string;
  description?: string;
}

export default class SimulationTask extends Task<Record<string, any>, ILinkedEntityPayload> {
  /**
   * Commands
   */

  static createTask = collectionCommand<ICreateTaskCmd, SimulationTask, typeof SimulationTask>(
    TaskCommands.CreateTask,
    {
      ajaxOptions: { queryParams: { include: 'createdBy,resolvedBy,assignees' } }
    }
  );

  static updateTask = collectionCommand<IUpdateTaskCmd, SimulationTask, typeof SimulationTask>(
    TaskCommands.UpdateTask
  );

  static deleteTask = collectionCommand<IDeleteTaskCmd, void, typeof SimulationTask>(
    TaskCommands.DeleteTask
  );

  static resolveTask = collectionCommand<IResolveTaskCmd, SimulationTask, typeof SimulationTask>(
    TaskCommands.ResolveTask
  );

  static reopenTask = collectionCommand<IReopenTaskCmd, SimulationTask, typeof SimulationTask>(
    TaskCommands.ReopenTask
  );

  // @ts-ignore
  [Type] = 'simulation-task' as const;
  static modelName = 'simulation-task';
}
